import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { ShadowedTemplateLinks } from '../../../shadowedTemplateLinks/ShadowedTemplateLinks'
import type { useDetectRebaseWorkspaceConflicts } from './useDetectRebaseWorkspaceConflicts'

type Props = {
  conflicts: ReturnType<typeof useDetectRebaseWorkspaceConflicts>
}

export const RebaseWorkspaceBranchConflicts = ({ conflicts }: Props) => {
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()

  const translate = useTranslate()

  return (
    <div className="flex flex-col gap-y-2">
      <Alert
        severity="warning"
        title={translate(
          'workspaceManagement.conflictsRebaseReview.description',
        )}
      />
      <ShadowedTemplateLinks
        branch={workspaceKey.branchKey}
        workspaceName={workspaceKey.name}
        conflicts={conflicts}
      />
    </div>
  )
}
